import footer from "./footer"
import navMenu from './headNav'
export default {
    footer: footer,
    navMenu: navMenu,
}